/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 17:32:48
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-25 20:02:10
 */
import { Request } from "./request";

export interface DoctorStationParams {
    current?: number;
    name?: string;
    organCode?: string;
    size?: number;
    tenantName?: string;
    title?: string;
}

export interface DoctorStationBody {
    anestheticDrugPermission?: boolean;
    createTime?: string;
    createUser?: number;
    doctorNumber?: string;
    id?: number;
    isDeleted?: number;
    name?: string;
    organCode?: string;
    property?: number;
    status?: number;
    tenantId?: number;
    tenantName?: string;
    title?: number;
    updateTime?: string;
    updateUse?: string;
}

export function DoctorStationPage(params: DoctorStationParams): Request {
    return {
        url: `/api/doctor/list`,
        method: "GET",
        params,
    }
}

export function DoctorStationDetail(id: number): Request {
    return {
        url: `/api/doctor/detail`,
        method: "GET",
        params: {
            id
        },
    }
}

export function DoctorStationSubmit(body: DoctorStationBody): Request {
    return {
        url: `/api/doctor/submit`,
        method: "POST",
        body
    }
}